import { DateTime } from 'luxon';
import type { ITimeRemaining } from './types';

// get a timestamp in EST with optional starting date
export const getTimestampInTimezone = (zone: string, dateString?: string): number => {
  if (dateString) {
    return DateTime.fromFormat(dateString, 'yyyy-MM-dd HH:mm:ss', { zone }).toMillis();
  } else {
    return DateTime.now().setZone(zone).toMillis();
  }
};

export const defaultTimer = { days: '00', hours: '00', minutes: '00', seconds: '00' };

export const calculateTimeRemaining = (zone: string, targetDate: number): ITimeRemaining => {
  const difference = targetDate - getTimestampInTimezone(zone);

  // set defaults, we want leading 0's
  if (difference <= 0) {
    return defaultTimer;
  }
  // calculate the days hours minutes and seconds.
  const days = Math.floor(difference / 86400000);
  const hours = Math.floor((difference % 86400000) / 3600000);
  const minutes = Math.floor((difference % 3600000) / 60000);
  const seconds = Math.floor((difference % 60000) / 1000);

  // return the countdown object with leading 0's
  return {
    days: days.toString().padStart(2, '0'),
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
};
